import { render, staticRenderFns } from "./RbuVolumeList.vue?vue&type=template&id=ede9f388"
import script from "./RbuVolumeList.vue?vue&type=script&lang=js"
export * from "./RbuVolumeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports